import { workSheetConstants } from '../../_constants';

const initialState = { getSharedWithUsersLoading: true, data: '', error: false };

export function getSharedWithUsersReducer(state = initialState, action) {
    switch (action.type) {
        case workSheetConstants.REQUEST_GET_SHARED_WITH_USERS:
            return {
                getSharedWithUsersLoading: true,
                data: '',
                error: false
            };
        case workSheetConstants.RECEIVE_GET_SHARED_WITH_USERS:
            return {
                getSharedWithUsersLoading: false,
                data: action.getSharedWithUsers,
                error: false
            };
        case workSheetConstants.GET_SHARED_WITH_USERS_ERROR:
            return {
                getSharedWithUsersLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/workSheet/getSharedWithUsers.reducer.js